import api from "../../components/api"
import { TenantWorkDaySetting } from "./tenantWorkDaySetting"

export const getTenantWorkDaySettingsData = async (): Promise<TenantWorkDaySetting[]> => {
  return (await api.get(`/web/tenant-work-day-settings`)).data
}

export const updateTenantWorkDaySetting = async (request: TenantWorkDaySetting): Promise<void> => {
  return (await api.post(`/web/tenant-work-day-settings`, request)).data
}